import type { ControllerParams } from '@wix/yoshi-flow-editor';

import * as feed from 'store/feed';
import type { IRootStore } from 'store/index';

import type { ICommentsVM } from './comments.vm';

export function CentralFeedVM(
  params: ControllerParams,
  comments: ICommentsVM,
  store: IRootStore,
) {
  return {
    centralFeed$: {
      fetch,
    },
  };

  async function fetch(cursor?: string, withComments = true) {
    const { data } = await store
      .dispatch(
        feed.thunks.fetchCentralFeed({
          cursor: {
            cursor,
            limit: 10,
          },
        }),
      )
      .unwrap();

    if (withComments) {
      await comments._.comments.fetch(data.items);
    }

    return data;
  }
}

export type ICentralFeedVM = ReturnType<typeof CentralFeedVM>;
